import { baseStrapiURL } from '../config';

/**
 * Service pour la création de mot de passe
 */
export const createPasswordService = {
    /**
     * Créer un mot de passe avec le token
     * @param {Object} data - Les données (token, password, confirmPassword)
     * @returns {Promise<Object>} Résultat de la création
     */
    async createPassword(data) {
        try {
            console.log('🔐 Création mot de passe...');

            const response = await fetch(`${baseStrapiURL}/api/auth/create-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error?.message || result.message || 'Erreur lors de la création');
            }

            console.log('✅ Mot de passe créé avec succès');
            return {
                success: true,
                ...result
            };

        } catch (error) {
            console.error('❌ Erreur création mot de passe:', error);
            
            return {
                success: false,
                message: error.message
            };
        }
    }
};